<template>
  <div class="w-full section-y px-4">
    <h2
      v-if="content?.title"
      class="text-teal-900 text-center section-title mb-10"
    >
      {{ content.title }}
    </h2>
    <div class="max-w-screen-xl mx-auto flex flex-col gap-16 md:gap-11">
      <div
        v-for="(section, index) in content?.section"
        :key="section?.id ?? index"
        class="flex flex-col gap-4 md:gap-10 md:items-center"
        :class="[
          twMerge(
            section?.imagePosition === 'left' && 'md:flex-row',
            section?.imagePosition === 'right' && 'md:flex-row-reverse',
            section?.imagePosition === 'bottom' && 'flex-col-reverse',
            section?.background !== 'white' && 'p-4 md:p-10 rounded-2xl',
            backgroundClass(section?.background)
          ),
        ]"
      >
        <div v-if="section?.image?.url" class="w-full md:w-6/12 shrink-0">
          <NuxtImg
            class="rounded-2xl object-cover w-full aspect-[530/364]"
            :src="String(section.image.url)"
            :alt="String(section.image.alternativeText || '')"
          />
        </div>
        <div class="w-full md:w-7/12 flex flex-col gap-2">
          <h3
            v-if="section?.title"
            class="text-teal-900 text-h6 font-semibold md:text-h3 leading-6"
            :class="[section?.background === 'dark' && 'text-stone-50']"
          >
            {{ section.title }}
          </h3>
          <p
            v-if="section?.description?.length"
            class="prose leading-normal"
            :class="[
              section?.background === 'dark'
                ? 'text-stone-50'
                : 'text-stone-700',
            ]"
          >
            {{
              section?.description
                ?.map((content) => content?.children?.[0]?.text)
                .join(' ')
            }}
          </p>
          <div v-if="section?.cta?.label" class="mt-2">
            <Button
              :color="section.cta.color"
              :link="section.cta.url"
              @click="handleCTA(section.cta.url)"
            >
              {{ section.cta.label }}
            </Button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { twMerge } from 'tailwind-merge'

const { toggleDateRequestSidebar } = useUiState()
const route = useRoute()
const emit = defineEmits(['openContactForm', 'openCaseStudyForm'])

const { content = {} } = defineProps<{ content: any }>()

const backgroundClass = (background: string) =>
  ({
    gray: 'bg-stone-100',
    dark: 'bg-teal-900',
    light: 'bg-stone-50',
    white: '',
  })[background] || ''

const handleCTA = (action: string) => {
  if (action === 'openEventRequestForm') {
    toggleDateRequestSidebar(route.name?.toString(), 'strapi_component')
  } else if (action === 'openPartnerContactForm') {
    emit('openContactForm')
  } else if (action === 'openCaseStudyForm') {
    emit('openCaseStudyForm')
  }
}
</script>

<style scoped lang="postcss">
:deep(.prose p) {
  margin: 0.25em 0;
}
</style>
